import * as roles from '../../../services/access/roles';
import {messages} from '../../common/Translations';
import {plainJSTranslator} from "../../../common/PlainJSTranslator";
import * as subscriptionTypes from "../../company/subscriptionType";

export let sidebar = [
    {
        id: 'rediger',
        to: '/profil/rediger',
        title: plainJSTranslator.formatMessage(messages.sideBarProfileItemCompanyProfile),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.MASKINSTATIONER_MINI,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'skab',
        to: '/profil/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterCreateCompanyProfile),
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'certifikater',
        to: '/profil/certifikater',
        title: plainJSTranslator.formatMessage(messages.sideBarProfileItemCertificates),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'brugere',
        to: '/brugere',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterUserList),
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'virksomhed',
        to: '/virksomhed',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterCompanyList),
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'products-list',
        to: '/produkt',
        title: plainJSTranslator.formatMessage(messages.sideBarProfileItemProducts),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'supplier-competencies',
        to: '/leverandør-kompetencer',
        title: plainJSTranslator.formatMessage(messages.sideBarProfileItemSupplierCompetencies),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'portal-contact',
        to: '/portal-kontakter',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterPortalContactList),
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'departments',
        to: '/afdelinger',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterPortalDepartmentList),
        roles: [roles.FBG_WEBMASTER],
    },
    {
        id: 'tips',
        to: '/tips',
        title: plainJSTranslator.formatMessage(messages.sideBarWebMasterTipList),
        roles: [roles.FBG_WEBMASTER],
    },
];

export let topNavbar = [
    {
        id: 'userprofil',
        to: '/user/profil',
        title: plainJSTranslator.formatMessage(messages.topBarUserProfile),
        icon: 'mdi mdi-account-settings',
        roles: [roles.MEMBER_ROLE ,roles.PARTNER_ROLE, roles.FBG_WEBMASTER],

    },
    {
        id: 'company-profil',
        to: '/profil/rediger',
        title: plainJSTranslator.formatMessage(messages.topBarCompanyProfile),
        icon: 'mdi mdi-domain',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
    },
    {
        id: 'statistics',
        to: '/statistik',
        title: plainJSTranslator.formatMessage(messages.topBarStatistics),
        icon: 'mdi mdi-chart-line',
        roles: [roles.PARTNER_ROLE, roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
        ],
    },
    {
        id: 'interests',
        to: '/interests',
        title: plainJSTranslator.formatMessage(messages.interests),
        icon: 'mdi mdi-airballoon',
        roles: [roles.MEMBER_ROLE],
    },
    {
        id: 'settings',
        to: '/indstillinger',
        title: plainJSTranslator.formatMessage(messages.topBarSettings),
        icon: 'mdi mdi-account-settings-variant',
        roles: [roles.FBG_WEBMASTER],

    },
];


// WEBPACK FOOTER //
// ./web/src/components/navigation/items/profileItems.jsx